// ML – toggle add/remove for product cards
// Состояние кнопок теперь синхронизируется с реальной корзиной + localStorage.
console.log('ML cart toggle script loaded');

/**
 * Работа с localStorage: запоминаем, какие variant_id "выбраны"
 */
function mlGetSelectedVariants() {
  try {
    var raw = localStorage.getItem('mlSelectedVariants');
    if (!raw) return {};
    var parsed = JSON.parse(raw);
    if (typeof parsed !== 'object' || parsed === null) return {};
    return parsed;
  } catch (e) {
    return {};
  }
}

function mlSaveSelectedVariants(map) {
  try {
    localStorage.setItem('mlSelectedVariants', JSON.stringify(map));
  } catch (e) {
    console.warn('ML cart: cannot save to localStorage', e);
  }
}

/**
 * Обновляем пузырёк корзины в хедере (по реальной корзине)
 */
function mlUpdateCartBubble(cart) {
  if (!cart || typeof cart.item_count === 'undefined') return;

  var count = cart.item_count;

  var candidates = [
    '[data-cart-count]',
    '[data-cart-count-bubble]',
    '[data-cart-items-count]',
    '#cart-icon-bubble .cart-count-bubble',
    '.ml-header-cart-count'
  ];

  var el = null;
  for (var i = 0; i < candidates.length; i += 1) {
    el = document.querySelector(candidates[i]);
    if (el) break;
  }

  if (!el) return;

  el.textContent = String(count);
  if (count > 0 && el.classList.contains('hidden')) {
    el.classList.remove('hidden');
  }
}

/**
 * После успешного изменения корзины просто обновляем счётчик в хедере
 */
function mlRefreshCartHeader() {
  return fetch('/cart.js', {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  })
    .then(function (response) {
      if (!response.ok) {
        throw new Error('ML cart: /cart.js failed, status ' + response.status);
      }
      return response.json();
    })
    .then(function (cart) {
      mlUpdateCartBubble(cart);
      return cart;
    })
    .catch(function (error) {
      console.error('ML cart header update error:', error);
    });
}

/**
 * Применяем состояние к кнопкам на основе переданной map
 * или, если map не передана, берём из localStorage.
 */
function mlApplySelectedFromStorage(presetSelected) {
  var selected = presetSelected || mlGetSelectedVariants();

  var buttons = document.querySelectorAll('[data-ml-add-to-cart]');
  buttons.forEach(function (btn) {
    var rawId = btn.dataset.variantId;
    var variantId = rawId ? String(rawId) : null;
    if (!variantId) return;

    if (selected[variantId]) {
      btn.classList.add('is-added');
    } else {
      btn.classList.remove('is-added');
    }

    btn.classList.remove('is-loading');
    btn.disabled = false;
  });
}

/**
 * Синхронизируем выбранные variant_id с реальной корзиной (/cart.js).
 * Если товар удалили из корзины, он пропадёт и из localStorage,
 * и кнопка перестанет быть "Added" при следующей загрузке страницы.
 */
function mlSyncSelectedWithCart() {
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  })
    .then(function (response) {
      if (!response.ok) {
        throw new Error('ML cart: /cart.js sync failed, status ' + response.status);
      }
      return response.json();
    })
    .then(function (cart) {
      var selected = {};

      if (cart && Array.isArray(cart.items)) {
        cart.items.forEach(function (item) {
          if (item && item.variant_id) {
            selected[String(item.variant_id)] = true;
          }
        });
      }

      // Сохраняем "истину" из корзины и применяем к кнопкам
      mlSaveSelectedVariants(selected);
      mlApplySelectedFromStorage(selected);
      mlUpdateCartBubble(cart);
    })
    .catch(function (error) {
      console.warn(
        'ML cart: cannot sync with cart.js, fallback to localStorage only',
        error
      );
      // Если /cart.js не отдался — хотя бы восстановим состояние из localStorage
      mlApplySelectedFromStorage();
    });
}

/**
 * Обработчик клика: только пользовательский клик меняет состояние
 * - если не было галочки → добавляем в корзину, ставим галочку, пишем в localStorage
 * - если была галочка → убираем из корзины, убираем галочку, чистим localStorage
 */
document.addEventListener('click', function (event) {
  var btn = event.target.closest('[data-ml-add-to-cart]');
  if (!btn) return;

  // 🔴 ВАЖНО: блокируем дефолтный submit формы и всплытие
  event.preventDefault();
  event.stopPropagation();

  var rawId = btn.dataset.variantId;
  var variantIdNum = rawId ? Number(rawId) : null;
  var variantIdKey = rawId ? String(rawId) : null;

  if (!variantIdNum || Number.isNaN(variantIdNum) || !variantIdKey) {
    console.warn('ML cart: no valid variant id on button', rawId, btn);
    return;
  }

  if (btn.classList.contains('is-loading')) {
    return;
  }

  var selected = mlGetSelectedVariants();
  var alreadySelected = !!selected[variantIdKey];

  btn.classList.add('is-loading');
  btn.disabled = true;

  var request;

  if (alreadySelected) {
    // Пользователь сам переключает обратно → убираем из корзины
    request = fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        updates: (function () {
          var obj = {};
          obj[variantIdKey] = 0;
          return obj;
        })()
      })
    });
  } else {
    // Пользователь добавляет → кладём в корзину
    request = fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: variantIdNum,
        quantity: 1
      })
    });
  }

  request
    .then(function (response) {
      if (!response.ok) {
        throw new Error('ML cart: change failed, status ' + response.status);
      }
      return response.json();
    })
    .then(function () {
      // обновляем header (счётчик корзины)
      mlRefreshCartHeader();

      // обновляем localStorage и визуальное состояние по клику
      var selectedNow = mlGetSelectedVariants();

      if (alreadySelected) {
        delete selectedNow[variantIdKey];
        btn.classList.remove('is-added');
      } else {
        selectedNow[variantIdKey] = true;
        btn.classList.add('is-added');
      }

      mlSaveSelectedVariants(selectedNow);

      btn.classList.remove('is-loading');
      btn.disabled = false;

      console.log(
        'ML cart: toggled by user, variant',
        variantIdKey,
        'selected:',
        !alreadySelected
      );
    })
    .catch(function (error) {
      console.error('ML cart error:', error);
      btn.classList.remove('is-loading');
      btn.disabled = false;
    });
});

// При загрузке страницы сначала синхронизируемся с реальной корзиной
mlSyncSelectedWithCart();
